import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { globals } from "../globals";

const API_URL = `${globals.homepageUrl}/php/usermanager.php`;

function UserManager() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({
    id: null,
    name: '',
    surname: '',
    password: '',
    email: '',
    role: ''
  });
  const [editing, setEditing] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(false);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await axios.get(API_URL);
      setUsers(res.data.users || []);
    } catch (err) {
      console.error('Errore nel recupero utenti:', err);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.surname || form.surname.trim() === '') {
      alert("Il cognome è obbligatorio e serve anche come password.");
      return;
    }

    try {
      if (editing) {
        await axios.put(API_URL, form);
      } else {
        // password = cognome in creazione
        await axios.post(API_URL, { ...form, password: form.surname });
      }
      setForm({ id: null, name: '', surname: '', email: '', password: '', role: '' });
      setEditing(false);
      setShowCreateForm(false);
      fetchUsers();
    } catch (err) {
      console.error('Errore nel salvataggio:', err);
    }
  };

  const handleEdit = (user) => {
    setForm({ ...user });
    setEditing(true);
    setShowCreateForm(false);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Sei sicuro di voler eliminare questo utente?')) {
      try {
        await axios.delete(API_URL, { data: { id } });
        fetchUsers();
      } catch (err) {
        console.error('Errore nell\'eliminazione:', err);
      }
    }
  };

  const handleResetPassword = async () => {
    if (!form.surname || form.surname.trim() === '') {
      alert("Il cognome non può essere vuoto per il reset della password.");
      return;
    }

    try {
      const payload = {
        ...form,
        password: form.surname,   // nuova password = cognome
        forceReset: true          // 🔴 flag amministrativo
      };

    const res = await axios.put(API_URL, payload);
      if (res.data?.error) {
        alert(res.data.error);
        return;
      }

      alert("Password resettata al cognome.");
      fetchUsers();
    } catch (err) {
      console.error('Errore nel reset password:', err);
      alert("Errore durante il reset della password");
    }
  };


  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Gestione Utenti</h2>

      {/* Tabella utenti */}
      <table style={{ ...styles.table, width: '100%', borderCollapse: 'separate', borderSpacing: '0 5px' }}>
        <thead>
          <tr>
            <th>Nome</th><th>Cognome</th><th>Email</th><th>Ruolo</th><th>Azioni</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.id}>
              <td>{u.name}</td>
              <td>{u.surname}</td>
              <td>{u.email}</td>
              <td>{u.role}</td>
              <td>
                <button style={styles.smallButton} onClick={() => handleEdit(u)}>Modifica</button>
                {u.role !== 'administrator' && (
                  <button
                    style={{ ...styles.smallButton, backgroundColor: '#d9534f' }}
                    onClick={() => handleDelete(u.id)}
                  >
                    Elimina
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Bottone per aprire form di creazione */}
      {!editing && (
        <div style={{ textAlign: 'center', margin: '20px 0' }}>
          <button style={styles.button} onClick={() => setShowCreateForm(true)}>
            Crea nuovo utente
          </button>
        </div>
      )}

      {/* Form di creazione */}
      {showCreateForm && !editing && (
        <form style={styles.form} onSubmit={handleSubmit}>
          <input style={styles.input} name="name" placeholder="Nome" value={form.name} onChange={handleChange} required />
          <input style={styles.input} name="surname" placeholder="Cognome" value={form.surname} onChange={handleChange} required />
          <input style={styles.input} name="email" placeholder="Email" value={form.email} onChange={handleChange} required />
          <select style={styles.input} name="role" value={form.role} onChange={handleChange} required>
            <option value="">-- Seleziona ruolo --</option>
            <option value="administrator">administrator</option>
            <option value="user">user</option>
          </select>
          <div style={styles.buttonRow}>
            <button type="submit" style={styles.button}>Crea</button>
            <button type="button" style={styles.cancelButton} onClick={() => setShowCreateForm(false)}>Annulla</button>
          </div>
        </form>
      )}

      {/* Form di modifica */}
      {editing && (
        <form style={styles.form} onSubmit={handleSubmit}>
          <input style={styles.input} name="name" placeholder="Nome" value={form.name} onChange={handleChange} required />
          <input style={styles.input} name="surname" placeholder="Cognome" value={form.surname} onChange={handleChange} required />
          <input style={styles.input} name="email" placeholder="Email" value={form.email} onChange={handleChange} required />
          <select style={styles.input} name="role" value={form.role} onChange={handleChange} required>
            <option value="">-- Seleziona ruolo --</option>
            <option value="administrator">administrator</option>
            <option value="user">user</option>
          </select>
          <div style={styles.buttonRow}>
            <button type="submit" style={styles.button}>Aggiorna Utente</button>
            <button
              type="button"
              style={styles.cancelButton}
              onClick={() => {
                setEditing(false);
                setForm({ id: null, name: '', surname: '', email: '', role: '' });
              }}
            >
              Annulla
            </button>
            <button
              type="button"
              style={{ ...styles.button, backgroundColor: '#ffc107', color: '#000' }}
              onClick={handleResetPassword}
            >
              Reset Password
            </button>
          </div>
        </form>
      )}
    </div>
  );
}

const styles = {
  container: { padding: '30px', fontFamily: 'Arial, sans-serif', maxWidth: '900px', margin: '0 auto', minHeight: '800px' },
  title: { textAlign: 'center', marginBottom: '20px' },
  form: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '30px' },
  input: { padding: '10px', fontSize: '16px', width: '100%', borderRadius: '6px', border: '1px solid #ccc' },
  buttonRow: { gridColumn: 'span 2', display: 'flex', gap: '10px', justifyContent: 'flex-end' },
  button: { padding: '10px 20px', backgroundColor: '#0d6efd', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  cancelButton: { padding: '10px 20px', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  table: { width: '100%', borderCollapse: 'collapse' },
  smallButton: { padding: '6px 10px', marginRight: '5px', backgroundColor: '#198754', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }
};

export default UserManager;
